<template>
  <custom-dialog
    :widthDialog="'760px'"
    :classDialog="'create-dialog'"
    :offsetTop="''"
    :openDialog="isOpen"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <div class="blkDocCreation chinh-sua-vb-vt">
        <div class="form-info">
          <el-form
            ref="form"
            :model="form"
            :rules="validationRules"
            inline-message
          >
            <div class="group__info margin-top-10 padding-bottom-10">
              <div class="title font-size__medium">Thông tin văn bản</div>
              <div class="content">
                <div class="form-input">
                  <el-form-item class="custom-label__input" prop="docCode">
                    <span class="label-input">Số ký hiệu: </span>

                    <el-input
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="form.docCode"
                      size=""
                      placeholder="-"
                      maxlength="100"
                      @change="docCodeChanged"
                    >
                    </el-input>
                  </el-form-item>

                  <el-form-item class="custom-label__input" prop="docDate">
                    <span class="label-input field-needed">Ngày văn bản: </span>
                    <el-date-picker
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      size=""
                      v-model="docDate"
                      type="date"
                      placeholder="dd/mm/yyyy"
                      :prefix-icon="' '"
                      format="dd/MM/yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item class="custom-label__input" prop="docTypeId">
                    <span class="label-input">Loại văn bản: </span>
                    <el-select
                      clearable
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="form.docTypeId"
                      size=""
                      filterable
                      placeholder="-"
                    >
                      <el-option
                        v-for="item in docTypes"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="custom-label__input" prop="publisherId">
                    <span class="flex-row flex__right label-input no_wrap">
                      <span>Đơn vị phát hành (bên trong)</span>
                      &nbsp;
                      <el-tooltip
                        content="Cây danh mục đơn vị"
                        placement="top"
                        effect="dark"
                      >
                        <i
                          class="fas fa-cog advance-search color__cyan clickable"
                          @click="isOpenSelectDepartmentDialog = true"
                        ></i>
                      </el-tooltip>
                    </span>
                    <el-select
                      filterable
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="form.publisherId"
                      placeholder="Nhập tên đơn vị để tìm kiếm"
                      clearable
                      @change="publisherIdChange"
                    >
                      <el-option
                        v-for="item in departments"
                        :label="customDeptName(item)"
                        :key="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="custom-label__input">
                    <span class="label-input"
                      >Đơn vị phát hành (bên ngoài):
                    </span>
                    <el-select
                      :disabled="!!form.publisherId"
                      :class="[
                        'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                        form.publisherId ? 'input-bg__transparent' : '',
                      ]"
                      v-model="form.outsidePublisherName"
                      filterable
                      allow-create
                      default-first-option
                      remote
                      reserve-keyword
                      :remote-method="remoteMethod"
                      :loading="isLoading"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                    >
                      <el-option
                        v-for="(item, index) in listInsideReceiver"
                        :key="index"
                        :label="item.deptName"
                        :value="item.deptName"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input"
                    v-if="incomingDoc && incomingDoc.forwardDeptName"
                  >
                    <span class="label-input">Nơi gửi: </span>
                    <el-input
                      :class="[
                        'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                        form.publisherId ? 'input-bg__transparent' : '',
                      ]"
                      v-model="incomingDoc.forwardDeptName"
                      size="mini"
                      placeholder="-"
                      maxlength="500"
                      :disabled="true"
                    >
                    </el-input>
                  </el-form-item>

                  <el-form-item class="custom-label__input" prop="quote">
                    <span class="label-input field-needed">Trích yếu</span>
                    <el-input
                      type="textarea"
                      rows="1"
                      maxlength="500"
                      v-model="form.quote"
                      placeholder="-"
                      autosize
                      resize="none"
                      class="input-font__bold style-fullWidth input-border__bottom input-border__radius__0"
                    ></el-input>
                  </el-form-item>

                  <el-form-item class="custom-label__input" prop="priorityId">
                    <span class="label-input">Độ khẩn: </span>
                    <multiselect
                      :class="[
                        form.priorityId ? '' : '',
                        'style-fullWidth input-font__bold',
                        'input-border__radius__0',
                      ]"
                      :options="priorities"
                      label="categoryName"
                      track-by="id"
                      :preselect-first="true"
                      v-model="priority"
                      placeholder="-"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :searchable="true"
                      open-direction="top"
                    >
                      <template slot="noResult"
                        >Không tìm thấy dữ liệu phù hợp.
                      </template>
                      <template slot="noOptions">Danh sách trống </template>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <el-tag
                          size="medium"
                          :class="[
                            'priority',
                            option.categoryName === 'Hỏa tốc' ? 'lv1' : '',
                            option.categoryName === 'Bình thường' ? 'lv3' : '',
                            option.categoryName === 'Khẩn' ? 'lv2' : '',
                          ]"
                        >
                          {{ option.categoryName }}
                        </el-tag>
                      </template>
                    </multiselect>
                  </el-form-item>

                  <!--              <div class="flex-row flex__left">-->
                  <el-row :gutter="12">
                    <el-col :span="15">
                      <el-form-item
                        class="custom-label__multiple__element"
                        prop="numberOfPage"
                      >
                        <span class="label-input">Số trang: </span>
                        <el-input-number
                          class="style-fullWidth input-font__bold"
                          v-model="form.numberOfPage"
                          placeholder="-"
                          size="mini"
                          :controls="true"
                          :min="0"
                          :step="1"
                          :precision="0"
                          :max="1000"
                        >
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item
                        class="custom-label__multiple__element"
                        prop="numberOfCopy"
                      >
                        <span class="label-input width__auto">Số bản: </span>
                        <el-input-number
                          :controls="true"
                          class="style-fullWidth input-font__bold"
                          v-model="form.numberOfCopy"
                          placeholder="-"
                          size="mini"
                          :min="0"
                          :step="1"
                          :precision="0"
                          :max="1000"
                        >
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--              </div>-->

                  <el-form-item class="custom-label__input" prop="numberOfCopy">
                    <span class="label-input">Hạn xử lý: </span>
                    <el-date-picker
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="deadlineDate"
                      type="date"
                      :prefix-icon="' '"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
          <div class="el-dialog__footer">
            <div class="flex-row flex__left form-button__action">
              <el-button
                class="dialogBtnPrimary"
                @click="saveDoc()"
                :disabled="isProcessing"
              >
                <el-tooltip content="Lưu văn bản" placement="top">
                  <span class="flex-row flex__center">
                    <i
                      :class="[
                        !isProcessing
                          ? 'font-size__small far fa-save'
                          : 'el-icon-loading',
                      ]"
                    ></i>
                    &nbsp;Lưu
                  </span>
                </el-tooltip>
              </el-button>
              <el-button
                type="info"
                class="btn__cancel btn-none__border"
                @click="cancel"
              >
                <el-tooltip content="Đóng" placement="top">
                  <span class="flex-row flex__center">
                    <i
                      class="font-size__small el-icon-circle-close-outline"
                    ></i>
                    &nbsp;Đóng
                  </span>
                </el-tooltip>
              </el-button>
            </div>
          </div>

          <select-department-dialog
            :isOpen="isOpenSelectDepartmentDialog"
            :publisherId="deptId"
            :receiveDepartmentIds="form.publisherId"
            v-if="isEnableSelectDepartmentDialog"
            @closed="isEnableSelectDepartmentDialog = false"
            @closeDialog="isOpenSelectDepartmentDialog = false"
            @change="publisherDepartmentChange"
          >
          </select-department-dialog>
        </div>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import categoryViewService from "../../../services/categoryViewService";
import constants from "../../../constants";
import h from "../../../services/h";
import departmentService from "../../../services/departmentService";
import dateUtils from "../../../dateUtils";
import docInService from "../../../services/docInService";
import buildAttachmentURL from "../../../filters/buildAttachmentURL.js";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import uploadFileMixin from ".././uploadFileMixin";
import tuChoiVanThuDialog from ".././components/tuChoiVanThuDialog";
import dateFormatter from "../../../filters/dateFormatter";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import otherDepartmentService from "../../../services/otherDepartmentService";
import Transfer from ".././components/TransferNewVanThu";
import vbIncomingDocService from "../../../services/vbIncomingDocService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CxlVbdenVanthuDialog from ".././components/clx-vbden-vanthu-dialog";
import CustomDialog from "../../common/custom-dialog";
import SelectDepartmentDialog from "./selectDepartmentDialog";

export default {
  name: "vb-den-update-dialog",
  mixins: [vbAttachmentTokenMixin, uploadFileMixin, handleRequestErrorMixin],
  filters: { buildAttachmentURL, dateFormatter, buildShortNameFilter },
  components: {
    SelectDepartmentDialog,
    CustomDialog,
    CxlVbdenVanthuDialog,
    Transfer,
    tuChoiVanThuDialog,
  },
  props: ["id", "isOpen"],
  data() {
    let publisherValidation = (rule, value, callback) => {
      return !this.form.publisherId && !this.form.outsidePublisherName
        ? callback(new Error("Đơn vị phát hành bắt buộc nhập"))
        : callback();
    };

    return {
      insideReceiver: null,
      listInsideReceiver: [],
      isLoading: false,
      selectedNodes: [],
      incomingDoc: null,
      priorities: [],
      docTypes: [],
      departments: [],
      docDate: null,
      incomingDate: null,
      deadlineDate: null,
      priority: null,

      form: {
        docCode: null,
        quote: null,
        attachmentId: null,
        publisherId: null,
        outsidePublisherName: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        priorityId: null,
        numberOfCopy: null,
        numberOfPage: null,
      },

      validationRules: {
        docDate: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
        ],
        publisherId: [{ validator: publisherValidation, trigger: "change" }],
        outsidePublisherName: [
          { validator: publisherValidation, trigger: "change" },
        ],
        quote: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
          {
            max: 2000,
            message: "Không vượt quá 2000 kí tự",
            trigger: "change",
          },
        ],
      },

      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
      isProcessing: false,
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
    };
  },

  computed: {
    docStatus() {
      if (this.incomingDoc && this.incomingDoc.vbOutgoingDocId)
        return this.incomingDoc.status;
      else return "";
    },

    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },
  },

  watch: {
    docDate(value) {
      this.form.docDate = value ? value.getTime() : null;
    },

    deadlineDate(value) {
      this.form.deadlineDate = value ? value.getTime() : null;
    },

    priority(newValue) {
      this.form.priorityId = newValue ? newValue.id : null;
    },

    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
  },

  created() {
    this.loadCategories();
    this.loadDepartments();
    this.loadDocDetail().then(() => this.prepareFormForEditMode());
  },

  methods: {
    docCodeChanged() {
      this.form.docCode = (this.form.docCode || "").toUpperCase();
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, { sort: "count,desc", page: 0, size: 20 })
        .then((res) => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    clearValidate() {
      this.$refs.form.clearValidate("publisherId");
    },

    publisherDepartmentChange(event) {
      let department = event.selectedDepartment;
      this.form.publisherId = department ? department.id : null;
      this.isOpenSelectDepartmentDialog = false;
    },

    publisherIdChange() {
      this.$refs.form && this.$refs.form.validateField("publisherId");
      this.form.outsidePublisherName = "";
    },

    cancel() {
      this.$emit("closeDialog");
    },

    saveDoc() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
        } else {
          let submitForm = this.convertToSubmitForm();
          this.isProcessing = true;
          docInService
            .updateIncomingDoc(this.id, submitForm)
            .then(() => {
              this.isProcessing = false;
              this.message(
                "Thông báo",
                "Lưu văn bản thành công",
                "success",
                4000
              );
              this.$emit("success");
            })
            .catch((error) => {
              this.isProcessing = false;
              return this.commonHandleRequestError(error);
            });
        }
      });
    },

    checkDocCodeDuplicated() {
      let docCode = this.form.docCode;
      docCode && (docCode = docCode.trim());
      if (!docCode) return Promise.resolve(true);
      return vbIncomingDocService
        .findAllByDocCodeAndToDeptId(docCode, this.id)
        .then((response) => {
          let vbIncomingDocs = response.data;
          if (!vbIncomingDocs || !vbIncomingDocs.length) return true;
          return this.$confirm(
            `Đã tồn tại văn bản với số ký hiệu [${docCode}]. Bạn vẫn muốn tiếp tục tiếp nhận văn bản này ?`,
            "Thông báo",
            {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Hủy bỏ",
              type: "warning",
            }
          ).then(() => true);
        });
    },

    loadDocDetail() {
      return docInService
        .findById(this.id)
        .then((response) => (this.incomingDoc = response.data));
    },

    prepareFormForEditMode() {
      this.form.docCode = this.incomingDoc.docCode;
      this.form.docTypeId = this.incomingDoc.docTypeId;
      this.form.publisherId = this.incomingDoc.publisherId;
      this.form.priorityId = this.incomingDoc.priorityId;
      this.form.numberOfPage = this.incomingDoc.numberOfPage;
      this.form.numberOfCopy = this.incomingDoc.numberOfCopy;
      this.form.quote = this.incomingDoc.quote;
      this.form.outsidePublisherName = this.incomingDoc.outsidePublisherName;
      this.docDate = this.incomingDoc.docDate
        ? dateUtils.toMoment(this.incomingDoc.docDate).toDate()
        : null;
      this.deadlineDate = this.incomingDoc.deadlineDate
        ? dateUtils.toMoment(this.incomingDoc.deadlineDate).toDate()
        : this.deadlineDate;
      // this.incomingDate = this.incomingDoc.incomingDate ? dateUtils.toMoment(this.incomingDoc.incomingDate).toDate() : null;

      /**
       * load thông tin priority;
       */
      this.incomingDoc.priorityId &&
        categoryViewService
          .findById(this.incomingDoc.priorityId)
          .then((response) => (this.priority = response.data));
    },

    convertToSubmitForm() {
      return {
        docCode: this.form.docCode,
        docTypeId: this.form.docTypeId,
        docDate: this.form.docDate,
        publisherId: this.form.publisherId,
        outsidePublisherName: this.form.outsidePublisherName,
        priorityId: this.priority ? this.priority.id : null,
        deadlineDate: this.form.deadlineDate,
        numberOfPage: this.form.numberOfPage,
        numberOfCopy: this.form.numberOfCopy,
        quote: this.form.quote,
      };
    },

    /**
     * filter lại danh sách đơn vị phát hành bên trong, chi cho phép ban hành trong đơn vị cha hoặc đơn vị ngang cấp
     * của đơn vị ban hành văn bản;
     */
    loadDepartments() {
      departmentService.findAll().then((response) => {
        let departments = h.findAll(
          response.data,
          (item) =>
            item.status === constants.DEPARTMENT.STATUS.ACTIVE ||
            item.id === this.form.publisherId
        );
        this.departments = departmentService
          .prepareReceiveDepartments(this.deptId, departments)
          .filter(
            (item) =>
              (item.deptType === this.DEPARTMENT_TREE.NODE_TYPE.DVTT ||
                !item.deptType ||
                item.parentId === "ROOT") &&
              item.id !== "ROOT"
          );
      });
    },

    loadCategories() {
      h.each(
        [
          constants.CATEGORY_GROUP_CODE.PRIORITY,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE,
          constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE,
        ],

        (item) => {
          categoryViewService
            .findAll(
              { groupCode: item },
              { sort: "order,asc", page: 0, size: 1000 }
            )
            .then((response) => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  return (this.priorities = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));
                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));
              }
            });
        }
      );
    },

    customDeptName(department) {
      return `${department.deptName} ${
        department.parentName ? ` (${department.parentName})` : ""
      }`;
    },
  },
};
</script>

<style scoped>
.chinh-sua-vb-vt .el-form {
    margin-bottom: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/vb-den-update-dialog.vue